import type { MerchantAccountSettingsRepositoryState } from "./types";

export const stateFactory: () => MerchantAccountSettingsRepositoryState = () => ({});
